import * as React from 'react';
import { useQuery } from '@apollo/client';

// GraphQL imports
import * as GqlShowOrganization from 'core/gql/queries/show-organizations';

type ReturnType = [orgData: any, error: any, loading: boolean];

export const useShowOrganization = (orgId: number): ReturnType => {
  const [orgData, setOrgData] = React.useState<any>(null);

  const { data, error, loading } = useQuery(GqlShowOrganization.QUERY, {
    variables: { organizationId: orgId },
    errorPolicy: 'all',
  });

  React.useEffect(() => {
    if (data) {
      setOrgData(data);
    }
  }, [data]);

  return [orgData, error, loading];
};
